module.exports = __webpack_public_path__ + "img/banner2.f2fe5f6f.png";